import Toast from '../../component/toastify/Index.jsx';
import axios from '../../axios/interceptor.js';

export const getCustomerUser = async (payload) => {
    try {
        const response = await axios.post('/customer/getAllCustomer', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const addCustomerUser = async (payload) => {
    try {
        const response = await axios.post('/customer/createCustomer', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateCustomerUser = async (id, payload) => {
    try {
        const response = await axios.put(`/customer/updateCustomer/${id}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteCustomerUser = async (id) => {
    try {
        const response = await axios.put(`/customer/deleteCustomer/${id}`, { isDelete: true })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const toggleCustomerStatus = async (id, isDelete) => {
    try {
        const response = await axios.put(`/customer/toggleCustomerStatus/${id}`, { isDelete: isDelete })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const getSingleCustomerUser = async (id) => {
    try {
        const response = await axios.get(`/customer/getCustomerById/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const resendCustomerEmail = async (email) => {
    try {
        const response = await axios.post(`/customer/resendCustomerInvitation/${email}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}